import Drawer from '../../../../Components/Drawer';
import USDTGroup from '../../../../assets/images/withdrawal/withdraw-processing-usdt-icon.png';
import WithdrawShine from '../../../../assets/images/withdrawal/withdraw-shine.png';

type TWithdrawCompletedModalProps = {
    open: boolean;
    onClose: () => void;
}

function WithdrawCompletedModal({ onClose, open }: TWithdrawCompletedModalProps) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      side="bottom"
      closeStroke="gray-10"
      wrapperClassName="px-4 bg-withdrawModalBg rounded-t-[20px] overflow-hidden text-[white] relative"
    >
      <div
        className="
            font-Bangers
            flex flex-col items-center
        "
      >
        <div
          className="
            z-[1]
            flex flex-col items-center
            transform translate-y-[-10%]
          "
        >
          <img
            src={USDTGroup}
            alt="usdt-icon"
            className="
                transform translate-y-[10%]
                my-6
            "
          />
          <span className="text-[32px] leading-[27px]">Congratulations!</span>
          <span className="text-lg mt-1">Withdrawal Completed</span>
        </div>
        <img
          src={WithdrawShine}
          alt="withdraw-shine"
          className="
            absolute
            inset-0
          "
        />
      </div>
    </Drawer>
  );
}

export default WithdrawCompletedModal;
